
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { KeyValue, TransferStockLocationModel } from "@tylertech/tyler-api-types";

/**
 * ItemLocationLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ItemLocationLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetItemLocations(pItemId: string): Promise<KeyValue[]> {
        return this.$apiService.sendAuth("IItemLocationLookupService/GetItemLocations", pItemId);
    }
    SaveItemLocation(transferStock: TransferStockLocationModel): Promise<boolean> {
        return this.$apiService.sendAuth("IItemLocationLookupService/SaveItemLocation", transferStock);
    }
}
